import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../../actions/candidate/candidate-applications/types';
import * as actions from '../../actions/candidate/candidate-applications';
import { setListSettings } from '../../actions/list-settings';

import listNames from '../../constants/list-names';
import applicationStatuses from '../../constants/application-statuses';

import { getListSettingsFromQueryParams } from '../../tools';
import queryStringify from '../../tools/query-stringify';
import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

function* getApplications({ queryParams }) {
  yield put(actions.setApplicationsListLoading(true));
  try {
    const { data } = yield apiFetcher.auth().get(`/candidates/current/applications?${queryStringify({ ...queryParams })}`);

    yield put(actions.setApplicationList(data));
    yield put(actions.setApplicationsQueryParams(queryParams))

    const queryParamsWithFullApplicationStatusesSet = {
      ...queryParams,
      statuses: Object.values(applicationStatuses)
    };

    const stats = yield apiFetcher
      .auth()
      .get(`/candidates/current/applications/status-stats?${queryStringify({ ...queryParamsWithFullApplicationStatusesSet })}`);

    yield put(actions.setApplicationsStatusStats(stats.data));

    const listSettings = yield getListSettingsFromQueryParams(queryParams);
    
    yield put(setListSettings(listNames.candidateApplications, listSettings)); 
  } catch (exception) {
    yield handleError(exception);
  }

  yield put(actions.setApplicationsListLoading(false));
}

function* getApplicationsSchools() {
  try {
    const { data } = yield apiFetcher.auth().get(`/candidates/current/schools`);
    yield put(actions.setApplicationsSchools(data));
  } catch (exception) {
    yield handleError(exception);
  }
}

function* getApplicationsCountries() {
  try {
    const { data } = yield apiFetcher.auth().get(`/lookups/countries`);
    yield put(actions.setApplicationsCountries(data));
    
  } catch (exception) {
    yield handleError(exception);
  }
}

export default function* applicationsSaga() {
  yield all([
    takeEvery(types.CANDIDATE_APPLICATIONS_GET_LIST, getApplications),
    takeEvery(types.CANDIDATE_APPLICATIONS_GET_SCHOOLS, getApplicationsSchools),
    takeEvery(types.CANDIDATE_APPLICATIONS_GET_COUNTRIES, getApplicationsCountries)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-applications.js